/*                                                          */
export const noop = (() => {}) as <A extends any[], R>(...args: A) => R;
